import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ngfModule } from "angular-file";
import { SignaturePadModule } from '@viablelogic/ngx-signature-pad';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { QuillModule } from 'ngx-quill';
import { SharedModule } from 'src/app/shared/shared.module';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';




import { CareersRoutingModule } from './careers-routing.module';
import { WelcomeComponent } from './welcome/welcome.component';
import { TasksComponent } from './tasks/tasks.component';
import { Filli9Component } from './filli9/filli9.component';
import { IdentificationComponent } from './identification/identification.component';
import { DirectDepositComponent } from './direct-deposit/direct-deposit.component';
import { EmergencyContactsComponent } from './emergency-contacts/emergency-contacts.component';
import { BrowseJobsComponent } from './browse-jobs/browse-jobs.component';
import { JobDetailsComponent } from './job-details/job-details.component';

import { ListViewModule } from '@syncfusion/ej2-angular-lists';
import { ApplyWithPinModalComponent } from '../../modals/careers/apply-with-pin-modal/apply-with-pin-modal.component';
import { ApplyJobModalComponent } from '../../modals/careers/apply-job-modal/apply-job-modal.component';

import {
  PdfViewerModule, LinkAnnotationService, BookmarkViewService,
  MagnificationService, ThumbnailViewService, ToolbarService,
  NavigationService, TextSearchService, TextSelectionService,
  PrintService, FormDesignerService, FormFieldsService, AnnotationService, ValidateFormFieldsArgs
} from '@syncfusion/ej2-angular-pdfviewer';

@NgModule({
  declarations: [
    WelcomeComponent,
    TasksComponent,
    Filli9Component,
    IdentificationComponent,
    DirectDepositComponent,
    EmergencyContactsComponent,
    BrowseJobsComponent,
    JobDetailsComponent,
    ApplyWithPinModalComponent,
    ApplyJobModalComponent
  ],
  imports: [
    BsDatepickerModule.forRoot(),
    BsDropdownModule.forRoot(),
    TimepickerModule.forRoot(),
    ModalModule.forRoot(),
    ListViewModule,
    CareersRoutingModule,
    CommonModule,
    FormsModule,
    ngfModule,
    NgSelectModule,
    NgbModule,
    QuillModule,
    ReactiveFormsModule,
    PaginationModule,
    SharedModule,
    SignaturePadModule,
    PdfViewerModule
  ],
  providers: [LinkAnnotationService, BookmarkViewService, MagnificationService,
    ThumbnailViewService, ToolbarService, NavigationService, AnnotationService,
    TextSearchService, TextSelectionService, PrintService, FormDesignerService, FormFieldsService]
})
export class CareersModule { }
